import React from "react";
import { useSelector } from "react-redux";
import { BrandHeader } from "components";
import RushHourPopup from "features/RushHourPopup";
import { navConfigKeys } from "components/brandHeader/UserNavPanel";
import StoreHeaderDetail from "components/StoreHeaderDetail";
import C from "Constants";
import useDelivertPickupFn from "features/hooks/useDelivertPickupFn";

const HomePageHeader = ({ isStorePage = false, searchTerm, handleSearch = () => { }, userNavPanelProps = {}, navPanelContainerstylesProps={}, ...rest }) => {

  const { goToSettings, goToLogin, viewBasketPage } = useDelivertPickupFn();
  const { brandInfo } = useSelector((state) => state?.brandStorageReducer);

  return (
    <>
      <BrandHeader
        page={true}
        hideUserNavPanel={false}
        navPanelContainerstylesProps={navPanelContainerstylesProps}
        userNavPanelProps={{
          navIconConfig: [navConfigKeys.search, navConfigKeys.cart],
          searchTerm: searchTerm,
          authClick: goToLogin,
          userClick: goToSettings,
          handleSearch: handleSearch,
          cartClick: viewBasketPage,
          showBackButton: true,
          ...userNavPanelProps,
        }}
      />
      <RushHourPopup />
      <StoreHeaderDetail
        page={isStorePage ? C.STORE : C.BRAND}
        brandInfo={brandInfo}
        headerTitle={brandInfo?.baseLanguage?.name}
        activeServices={[]}
        hideDescription={false}
        containerStyleProps={{
          style: {
            padding: "16px",
            paddingBottom: "0px",
          },
        }}
        hideStoreRatting={true}
        showArrow={false}
        {...rest}
      />
    </>
  );
};

export default HomePageHeader;
